import { Stack } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import "../../common/styles/common.scss";
import { parentRoutes } from "../../constants/constants";
import { matchRoutesFromMenuStructure } from "../../utils/Utilities";
// import { yourAssetsLinks } from "../../constants/constants";
const SideBar = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const yourAssetsLinks = [
    {
      id: 1,
      name: t("sidebar-1-text-1"),
      to: "family-tree",
      route: "/your-assets/family-tree",
    },
    {
      id: 2,
      name: t("sidebar-1-text-2"),
      to: "balance-of-assets",
      route: "/your-assets/balance-of-assets",
    },
    {
      id: 4,
      name: t("sidebar-3-text-6"),
      to: "total-asset-value",
      route: "/your-assets/total-asset-value",
    },
    {
      id: 4,
      name: t("sidebar-3-text-7"),
      to: "donations",
      route: "/your-assets/donations",
    },
    // {
    //   id: 3,
    //   name: t("sidebar-1-text-3"),
    //   to: "shares-of-inheritance",
    //   route: "/your-assets/shares-of-inheritance",
    // },
  ];

  return (
    <>
      <Stack
        className="side-bar"
        // sx={{ width: "max-content" }}
      >
        {yourAssetsLinks
          .filter((ele1) =>
            matchRoutesFromMenuStructure("assets").some(
              (ele2) => ele1.to === ele2.route
            )
          )
          ?.map((item) => (
            <Link
              key={item.id}
              to={item.to}
              className={`side-link${
                location.pathname === item.route ? " active" : ""
              }`}
            >
              {item.name}
            </Link>
          ))}
      </Stack>
    </>
  );
};

export default SideBar;
